module.exports = __webpack_public_path__ + "static/img/product-poster-4.781095b2.png";